// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html {
    font-size: 100%;
    box-sizing: border-box;
    scroll-behavior: smooth;
    overflow-y: overlay;
  }

  * {
    box-sizing: inherit;
    font-family: IRANSansfa !important;
    direction: rtl !important;
  }

  input,
  select,
  button {
    font: inherit;
  }
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
  .container {
    width: min(90vw, 1500px);
    margin-inline: auto;
  }

  .placeholder::placeholder {
    font-family: inherit;
  }
.visible {
  visibility: visible;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.bottom-8 {
  bottom: 2rem;
}
.left-5 {
  left: 1.25rem;
}
.left-8 {
  left: 2rem;
}
.right-0 {
  right: 0px;
}
.right-1\\/2 {
  right: 50%;
}
.right-2 {
  right: 0.5rem;
}
.right-\\[0\\] {
  right: 0;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-\\[20px\\] {
  top: 20px;
}
.top-\\[83px\\] {
  top: 83px;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.col-span-4 {
  grid-column: span 4 / span 4;
}
.m-0 {
  margin: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}
.mx-7 {
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}
.mx-\\[1\\.2rem\\] {
  margin-left: 1.2rem;
  margin-right: 1.2rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.-ml-2 {
  margin-left: -0.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.ml-8 {
  margin-left: 2rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-16 {
  height: 4rem;
}
.h-20 {
  height: 5rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[25px\\] {
  height: 25px;
}
.h-\\[3\\.07rem\\] {
  height: 3.07rem;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[75px\\] {
  height: 75px;
}
.h-fit {
  height: fit-content;
}
.h-full {
  height: 100%;
}
.max-h-\\[190px\\] {
  max-height: 190px;
}
.max-h-\\[200px\\] {
  max-height: 200px;
}
.max-h-fit {
  max-height: fit-content;
}
.min-h-\\[100vh\\] {
  min-height: 100vh;
}
.min-h-\\[2rem\\] {
  min-height: 2rem;
}
.min-h-\\[300px\\] {
  min-height: 300px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-16 {
  width: 4rem;
}
.w-20 {
  width: 5rem;
}
.w-36 {
  width: 9rem;
}
.w-44 {
  width: 11rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[25px\\] {
  width: 25px;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[75px\\] {
  width: 75px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[95\\%\\] {
  width: 95%;
}
.w-full {
  width: 100%;
}
.min-w-\\[16rem\\] {
  min-width: 16rem;
}
.min-w-max {
  min-width: max-content;
}
.max-w-\\[400px\\] {
  max-width: 400px;
}
.max-w-md {
  max-width: 28rem;
}
.shrink {
  flex-shrink: 1;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/2 {
  --tw-translate-x: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-skew-y-6 {
  --tw-skew-y: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-7 {
  gap: 1.75rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-x-8 {
  column-gap: 2rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-4 {
  row-gap: 1rem;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-200 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-divide-opacity, 1));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-r-2 {
  border-right-width: 2px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-\\[\\#0000003b\\] {
  border-color: #0000003b;
}
.border-\\[\\#8F8F8F\\] {
  --tw-border-opacity: 1;
  border-color: rgb(143 143 143 / var(--tw-border-opacity, 1));
}
.border-\\[\\#CBCBCB\\] {
  --tw-border-opacity: 1;
  border-color: rgb(203 203 203 / var(--tw-border-opacity, 1));
}
.border-\\[\\#a1a3a8\\] {
  --tw-border-opacity: 1;
  border-color: rgb(161 163 168 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cbcbcb\\] {
  --tw-border-opacity: 1;
  border-color: rgb(203 203 203 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4dae3\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 218 227 / var(--tw-border-opacity, 1));
}
.border-\\[\\#dbdfea\\] {
  --tw-border-opacity: 1;
  border-color: rgb(219 223 234 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f0f2f5\\] {
  --tw-border-opacity: 1;
  border-color: rgb(240 242 245 / var(--tw-border-opacity, 1));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#1b1c30\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(27 28 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3C74D1\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(60 116 209 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#EBEBEB\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(235 235 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\] {
  background-color: rgba(0,0,0,0.2);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-300 {
  --tw-gradient-from: #93c5fd var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 197 253 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-600 {
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-7 {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[1\\.2rem\\] {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-2 {
  padding-left: 0.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-7 {
  padding-left: 1.75rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[0\\.78rem\\] {
  font-size: 0.78rem;
}
.text-\\[0\\.7rem\\] {
  font-size: 0.7rem;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[7px\\] {
  font-size: 7px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[500\\] {
  font-weight: 500;
}
.font-bold {
  font-weight: 700;
}
.font-semibold {
  font-weight: 600;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#001ee4\\] {
  --tw-text-opacity: 1;
  color: rgb(0 30 228 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0082fd\\] {
  --tw-text-opacity: 1;
  color: rgb(0 130 253 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0d0c0c\\] {
  --tw-text-opacity: 1;
  color: rgb(13 12 12 / var(--tw-text-opacity, 1));
}
.text-\\[\\#13318f\\] {
  --tw-text-opacity: 1;
  color: rgb(19 49 143 / var(--tw-text-opacity, 1));
}
.text-\\[\\#141414\\] {
  --tw-text-opacity: 1;
  color: rgb(20 20 20 / var(--tw-text-opacity, 1));
}
.text-\\[\\#147CAF\\] {
  --tw-text-opacity: 1;
  color: rgb(20 124 175 / var(--tw-text-opacity, 1));
}
.text-\\[\\#262626\\] {
  --tw-text-opacity: 1;
  color: rgb(38 38 38 / var(--tw-text-opacity, 1));
}
.text-\\[\\#328d4a\\] {
  --tw-text-opacity: 1;
  color: rgb(50 141 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#364a63\\] {
  --tw-text-opacity: 1;
  color: rgb(54 74 99 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4D4D4D\\] {
  --tw-text-opacity: 1;
  color: rgb(77 77 77 / var(--tw-text-opacity, 1));
}
.text-\\[\\#61A6FF\\] {
  --tw-text-opacity: 1;
  color: rgb(97 166 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8094ae\\] {
  --tw-text-opacity: 1;
  color: rgb(128 148 174 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8c8c8c\\] {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#93989e\\] {
  --tw-text-opacity: 1;
  color: rgb(147 152 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF3400\\] {
  --tw-text-opacity: 1;
  color: rgb(255 52 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d32f2f\\] {
  --tw-text-opacity: 1;
  color: rgb(211 47 47 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fff\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.opacity-40 {
  opacity: 0.4;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-0 {
  outline-width: 0px;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.duration-75 {
  transition-duration: 75ms;
}
.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.enterDrag {
  animation: myfirst 6s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  background-color: transparent;
  background-image: linear-gradient(
      0deg,
      transparent,
      transparent 50%,
      rgb(82, 80, 80) 0,
      rgb(82, 80, 80)
    ),
    linear-gradient(
      0deg,
      transparent,
      transparent,
      transparent 50%,
      rgb(82, 80, 80) 0,
      rgb(82, 80, 80)
    ),
    linear-gradient(
      90deg,
      transparent,
      transparent 50%,
      rgb(82, 80, 80) 0,
      rgb(82, 80, 80)
    ),
    linear-gradient(
      90deg,
      transparent,
      transparent 50%,
      rgb(82, 80, 80) 0,
      rgb(82, 80, 80)
    );
  background-repeat: repeat-y, repeat-y, repeat-x, repeat-x;
  background-size: 2px 20px, 2px 20px, 20px 2px, 20px 2px;
  opacity: 0.7;
  border-radius: 8px;
}
@keyframes myfirst {
  0% {
    background-position: 0 0, 100% 100%, 100% 0, 0 100%;
  }
  100% {
    background-position: 0 +100px, 100% 0%, 0 0, 100% 100%;
  }
}
.leftTextArea textarea {
  direction: ltr !important;
}
.MuiPagination-ul {
  flex-direction: row-reverse !important;
}
.tether-element {
  z-index: 10000;
}
.datepicker-input {
  display: none;
  position: absolute;
  top: 0;
}
.rc-time-picker {
  display: none !important;
}
.border-print {
  /*   border-radius: 10px !important;
  border: 1px solid gray !important; */
  /*   margin-top: 10px !important;
  margin-bottom: 10px !important; */
  padding-left: 40px !important;
  padding-right: 40px !important;

  line-height: 22px;
  font-size: 15px;
}

.border-print h1.text-center {
  text-align: center !important;
}

.border-print h2.text-center {
  font-size: 16px;
}

button.btn.hamtaBtn.text-white.blacColorHover {
  width: 40%;
}

.border-print > p {
  text-align: center;
  color: red;
}

/*invoice print responsive ------------------*/

@media only screen and (max-width: 768px) {
  .border-print {
    max-width: 405px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-size: 13px;
  }
  .border-print .row {
    margin-bottom: 5px !important;
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
  }
  .border-print > div:nth-child(4) > div > div {
    overflow-y: hidden;
  }
}
.alert-warning {
  color: #ff0000;
  background-color: #ffffff;
  border-color: white;
  padding-top: 50px;
}
.table-hover tbody tr:hover {
  background-color: rgb(106 148 255 / 8%);
  border: 1px solid #ff090936 !important;
}

tr.GridViewHeader {
  border: 2px solid #b7b7b7 !important;
  background: #f1f1f1;
}

tr.GridViewHeader > th {
  border-bottom: 2px solid #b7b7b7 !important;
}
.alert-dark {
  color: #1b1e21;
  background-color: #d6d8d9;
  border-color: #c6c8ca;
}
.alert-dark hr {
  border-top-color: #b9bbbe;
}
.alert-dark .alert-link {
  color: #040505;
}
.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

#printContent span,
#printContent p,
#printContent th,
#printContent td {
  font-size: 12px !important;
}
.MuiFormControl-root .Mui-disabled {
  color: #040505 !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #040505 !important;
}

.invoicePage .border-print {
  /*   border-radius: 0px !important; */
  /*   border: 1px solid gray !important; */
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 3px !important;
  padding-bottom: 3px !important;
  line-height: 16px;
  font-size: 15px;
}

.invoicePage
  .text-left.flex.items-center.justify-between.w-48.text-base.font-bold {
  font-size: 10px;
  font-weight: 500;
}

.invoicePage thead.bg-\\[\\#d6d8d9\\] {
  background: #eaeaea;
}

.invoicePage tr.text-center th {
  font-weight: 400;
}

.invoicePage span.text-sm.font-bold {
  font-weight: 300;
}

.invoicePage span.text-xs {
  font-weight: 500;
}

.invoicePage tr.bg-\\[\\#d6d8d9\\] {
  background: #eaeaea;
}

.invoicePage h2.text-center.font-extrabold {
  font-size: 12px;
}

.invoicePage .text-sm {
  font-size: 12px;
  line-height: 12px;
}

.invoicePage .col-span-3.bg-\\[\\#d6d8d9\\].py-2.border.border-black.mt-3 {
  padding: 2px;
}
.invoicePage .col-span-3.bg-\\[\\#d6d8d9\\].py-2.border.border-black {
  padding: 2px;
}
.invoicePage h1.text-center.text-base.font-bold {
  font-size: 12px;
}

.invoicePage #printContent span,
#printContent p,
#printContent th,
#printContent td {
  font-size: 11px !important;
}

.invoicePage
  .text-left.flex.items-center.justify-between.w-48.text-base.font-bold {
  font-size: 11px;
}

.invoicePage .w-48 {
  width: 100px;
}

.invoicePage .pt-6 {
  padding-top: 12px;
}

.invoicePage .gap-4.mt-10.mb-1.pt-6 {
  margin: 0;
}

#printContent {
  border: none !important;
}
.checkBoxDisabled.Mui-disabled {
  background-color: #fff !important;
  color: #595959 !important;
}
.checkBoxDisabled .Mui-disabled {
  background-color: #fff !important;
  color: #595959 !important;
}
.smallNumberInput .MuiTextField-root {
  width: 50px !important;
}
.smallNumberInput input {
  text-align: center !important;
}
.noborderBefore::before {
  background-color: transparent !important;
}
.MuiDrawer-paper {
  right: 0 !important;
  left: auto !important;
}
.tabss .Mui-disabled {
  background-color: transparent !important;
}
.loadingPage {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  backdrop-filter: blur(5px);
  filter: blur(5px);
  z-index: 1000;
}
.btn {
  align-items: center;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  display: inline-flex;

  justify-content: center;
  min-width: 90px;
}
.btn.btn--loading {
  font-size: 0;
  position: absolute;
  right: 50%;
  top: 50%;
  transform: translate(50%, -50%);
}
.btn.btn--loading span {
  display: flex;
}
.btn.btn--loading span b {
  animation-direction: alternate;
  animation-duration: 0.5s;
  animation-fill-mode: none;
  animation-iteration-count: infinite;
  animation-name: stretch;
  animation-play-state: running;
  animation-timing-function: ease-out;
  border-radius: 100%;
  display: block;
  height: 10px;
  width: 10px;
  animation-delay: 0.1s;
  margin: 0 5px;
}
.btn.btn--loading span b:first-child {
  animation-delay: 0s;
  margin: 0;
}
.btn.btn--loading span b:last-child {
  animation-delay: 0.2s;
  margin: 0;
}
.btn b {
  font-weight: normal;
}
.btn span {
  display: none;
}
@keyframes stretch {
  0% {
    transform: scale(0.5);
    background-color: #b5ddf0;
  }
  50% {
    background-color: #cfe9f6;
  }
  100% {
    transform: scale(1);
    background-color: #ffffff;
  }
}

.sidebar::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

  background-color: #f5f5f5;
}

.sidebar::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
  display: none !important;
}
.sidebar:hover::-webkit-scrollbar {
  display: block !important;
}
.sidebar::-webkit-scrollbar-thumb {
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #d5d6d8;
}

/* html::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);

  background-color: #f5f5f5;
}

html::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

html::-webkit-scrollbar-thumb {
  border-radius: 6px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #6e747a;
}
 */
.MuiTableCell-sizeMedium {
  font-size: 0.77rem !important;
}
.MuiTableCell-body {
  font-size: 0.77rem !important;
}
.MuiTableCell-root {
  padding: 6px 4px !important;
}
/* .MuiTableContainer-root::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.MuiTableContainer-root::-webkit-scrollbar {
  width: 12px;
  background-color: #f5f5f5;
  border-radius: 10px;
}

.MuiTableContainer-root::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #6e747a;
} */
.MuiInputBase-root {
  height: 3.07rem !important;
}

.MuiFormLabel-root {
  font-size: 0.75rem !important;
  transform: translate(-14px, 0.9rem) scale(1) !important;
}
.MuiInputLabel-shrink {
  transform: translate(-14px, -0.57rem) scale(0.75) !important;
  color: #001ee4 !important;
}
.MuiOutlinedInput-root {
  padding-left: 0 !important;
}
.MuiInputBase-input {
  font-size: 0.75rem !important;
  padding: 6px !important;
  font-weight: 500 !important;
}

.MuiInputBase-multiline {
  height: unset !important;
}
.tox-promotion {
  display: none !important;
}
.tox-statusbar__branding {
  display: none !important;
}
.tox-statusbar__wordcount {
  display: none !important;
}
.MuiCircularProgress-root {
  width: 20px !important;
  height: 20px !important;
}
.userInput .MuiInputBase-root {
  height: 26px !important;
}
.login .MuiInputBase-root {
  height: 40px !important;
}

.img-croper-body {
  width: 100%;
  min-height: 400px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-croper-body img {
  max-width: 500px !important;
  max-height: 500px !important;
  width: 100%;
  height: 100%;
  min-height: 400px;
  min-width: 400px;
}
.img-croper-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
.MuiButtonBase-root {
  font-size: 0.9rem !important;
  padding: 4px 6px !important;
  font-weight: 400 !important;
}
.MuiTabs-root .Mui-selected {
  background-color: #d8effa !important;
}

.MuiAutocomplete-root .MuiInputBase-root {
  height: unset !important;
}

.MuiSwitch-switchBase {
  padding: 9px !important;
}

.MuiListItemIcon-root {
  min-width: 35px !important;
}
.sideBarActive {
  position: absolute;
  right: -24px;
  width: 4px;
  height: 20px;
  background: #001ee4;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
textarea {
  resize: vertical !important;
}
.MuiButtonBase-root {
  box-shadow: none !important;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.selectToday {
  background-color: #198dff;
}
.MuiButton-contained {
  height: 3.07rem !important;
  font-size: 0.75rem !important;
}
.MuiCheckbox-root svg {
  width: 0.8em;
  height: 0.8em;
}
.MuiAutocomplete-tag {
  margin: 5px !important;
  background-color: rgba(25, 63, 210, 0.08) !important;
  border: unset !important;
  color: black !important;
}
.MuiAutocomplete-tag .MuiSvgIcon-root {
  color: rgba(244, 95, 97, 0.729) !important;
}
.MuiChip-label {
  font-weight: 500 !important;
}
.MuiAutocomplete-clearIndicator {
  visibility: visible !important;
  color: rgb(244, 95, 97) !important;
}
.customAddButton {
  font-size: 1.5rem !important;
  color: #fff !important;
  background-color: #60b5db !important;
  border-radius: 55px !important;
  width: 1em !important;
  height: 1em !important;
}
.MuiButton-outlined {
  height: 3.07rem !important;
  font-size: 0.75rem !important;
}
.login .MuiFormLabel-root,
.login .MuiInputBase-input {
  font-size: 1.3rem !important;
}
.biggerInput .MuiFormLabel-root,
.biggerInput .MuiInputBase-input {
  font-size: 1rem !important;
}

.bigTable .MuiTableCell-body {
  font-size: 1rem !important;
}
.MuiChip-label {
  font-size: 0.75rem !important;
}
@media only screen and (max-width: 768px) {
  .MuiInputBase-input,
  .MuiFormLabel-root,
  .MuiButton-contained,
  span,
  p,
  small,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  input label,
  a,
  td,
  tr,
  th,
  .MuiTypography-root,
  .MuiTableCell-body,
  div {
    font-size: 14px !important;
  }
  .MuiChip-label {
    font-size: 0.7rem !important;
  }
  .ril-image-current {
    transform: none !important;
    width: 100% !important;
    /*     height: 100% !important; */
  }
  .ril-zoom-in {
    display: none !important;
  }
  .ril-zoom-out {
    display: none !important;
  }
  .MuiAutocomplete-popper {
    max-width: 300px !important;
    /*     left: 0!important; */
  }
  .smalllerText {
    font-size: 0.77rem !important;
  }
}
.darkMode .MuiTabs-root .Mui-selected {
  background-color: #25114f !important;
}
.darkMode .MuiFormControl-root .Mui-disabled {
  color: #b2dada !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #c4f1f1 !important;
}
.darkMode .MuiInputLabel-shrink {
  transform: translate(-14px, -0.57rem) scale(0.75) !important;
  color: #90caf9 !important;
}
.darkMode .text-\\[\\#000\\] {
  color: #fff !important;
}
.darkMode .MuiAutocomplete-tag {
  color: #b2dada !important;
}
.darkMode button[disabled],
button[disabled]:hover {
  color: #aaa;
  cursor: not-allowed;
  background-color: #403f3f !important;
}
.MuiTabs-scroller {
  overflow-x: hidden !important;
}
.MuiTabs-scroller:hover {
  overflow-x: auto !important;
}
.MuiTabs-scroller::-webkit-scrollbar-track {
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);

  background-color: #f5f5f5;
}

.MuiTabs-scroller::-webkit-scrollbar {
  height: 4px;
  background-color: #f5f5f5;
}

.MuiTabs-scroller::-webkit-scrollbar-thumb {
  border-radius: 3px;
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #6e747a;
}
.iranMap path {
  fill: white;
}
.noPadding .MuiSwitch-switchBase {
  padding: 0px !important;
}
.noPadding .MuiSwitch-thumb {
  position: relative;
  z-index: 10;
}

.MuiButton-contained {
  color: #fff !important;
}

.ril__closeButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    no-repeat center !important;
}

.ril__zoomInButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    no-repeat center !important;
}

.ril__zoomOutButton {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    no-repeat center !important;
}
.ril-image-current {
  border-radius: 10px;
}
.MapMainCom {
  width: 100%;
  height: 40rem;
  z-index: 100;
  position: relative;
  margin-top: 2rem;
  border-radius: 10px;
  overflow: hidden;
}

.MapMainCom .leaflet-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.leaflet-div-icon {
  border: 0 !important;
  background: transparent !important;
}
.leftInput input {
  direction: ltr !important;
}
.leftInput .MuiAutocomplete-endAdornment {
  left: unset !important;
  right: 10px !important;
}
.leftInput .MuiAutocomplete-root .MuiFormControl-root {
  height: 3rem !important;
}
.leftInput .MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 7px;
}
.hover\\:scale-90:hover {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-r-blue-400:hover {
  --tw-border-opacity: 1;
  border-right-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.hover\\:bg-blue-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.hover\\:text-\\[\\#FF3400\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(255 52 0 / var(--tw-text-opacity, 1));
}
.hover\\:text-blue-500:hover {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.hover\\:transition-colors:hover {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
@media (min-width: 640px) {

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:w-\\[11\\.25rem\\] {
    width: 11.25rem;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-\\[352px\\] {
    min-width: 352px;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:-rotate-6 {
    --tw-rotate: -6deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:skew-y-0 {
    --tw-skew-y: 0deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:leading-7 {
    line-height: 1.75rem;
  }
}
@media (min-width: 768px) {

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-12 {
    height: 3rem;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:h-\\[30px\\] {
    height: 30px;
  }

  .md\\:h-\\[60px\\] {
    height: 60px;
  }

  .md\\:min-h-\\[150px\\] {
    min-height: 150px;
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-24 {
    width: 6rem;
  }

  .md\\:w-96 {
    width: 24rem;
  }

  .md\\:w-\\[30px\\] {
    width: 30px;
  }

  .md\\:w-\\[350px\\] {
    width: 350px;
  }

  .md\\:w-\\[400px\\] {
    width: 400px;
  }

  .md\\:w-\\[60px\\] {
    width: 60px;
  }

  .md\\:w-\\[90\\%\\] {
    width: 90%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-\\[400px\\] {
    min-width: 400px;
  }

  .md\\:max-w-\\[16rem\\] {
    max-width: 16rem;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:gap-10 {
    gap: 2.5rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:rounded-md {
    border-radius: 0.375rem;
  }

  .md\\:border {
    border-width: 1px;
  }

  .md\\:border-0 {
    border-width: 0px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
@media (min-width: 1280px) {

  .xl\\:min-w-\\[95vw\\] {
    min-width: 95vw;
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,eAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,mBAAc;EAAA;;EAAd;IAAA,mBAAc;IAAd,kCAAc;IAAd,yBAAc;EAAA;;EAAd;;;IAAA,aAAc;EAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;EAwBlB;IACE,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AA9BF;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAiCnB;EACE,qBAAqB;EACrB,iCAAiC;EACjC,mCAAmC;EACnC,6BAA6B;EAC7B;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA4BG;EACH,yDAAyD;EACzD,uDAAuD;EACvD,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE;IACE,mDAAmD;EACrD;EACA;IACE,sDAAsD;EACxD;AACF;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sCAAsC;AACxC;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;AACR;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;sCACoC;EACpC;mCACiC;EACjC,6BAA6B;EAC7B,8BAA8B;;EAE9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,8CAA8C;;AAE9C;EACE;IACE,2BAA2B;IAC3B,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,uCAAuC;EACvC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;;;EAIE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,oBAAoB;;EAEpB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,+BAA+B;AACjC;AACA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,yBAAyB;EACzB,mCAAmC;EACnC,uBAAuB;EACvB,6BAA6B;EAC7B,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,YAAY;EAEZ,WAAW;EACX,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,qBAAqB;EACrB,SAAS;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,qBAAqB;IACrB,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE,4CAA4C;;EAE5C,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,yBAAyB;EAIzB,wBAAwB;AAH1B;AAKA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;EAgBE;AACF;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;;;;;;;;;;;;;;;;GAgBG;AACH;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,uDAAuD;AACzD;AACA;EACE,4DAA4D;EAC5D,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,8CAA8C;EAC9C,wBAAwB;EACxB,SAAS,EAAE,uEAAuE;AACpF;;AAEA;EACE,0BAA0B,EAAE,YAAY;AAC1C;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;;;;EAIE,qDAAqD;AACvD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,oDAAoD;EACpD,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;AACA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,oCAAoC;EACpC,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;;EAEE,4BAA4B;AAC9B;AACA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;;;;;;;;;;;;;;;;;;;;IAoBE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,sBAAsB;IACtB,iCAAiC;EACnC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,4DAA4D;EAC5D,yBAAyB;AAC3B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4CAA4C;;EAE5C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;EAC5C,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;+BAC6B;AAC/B;;AAEA;EACE;+BAC6B;AAC/B;;AAEA;EACE;+BAC6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AAtwBA;EAAA,gBAuwBA;EAvwBA,gBAuwBA;EAvwBA;AAuwBA;AAvwBA;EAAA,sBAuwBA;EAvwBA;AAuwBA;AAvwBA;EAAA,kBAuwBA;EAvwBA;AAuwBA;AAvwBA;EAAA,oBAuwBA;EAvwBA;AAuwBA;AAvwBA;EAAA,oBAuwBA;EAvwBA;AAuwBA;AAvwBA;EAAA,+FAuwBA;EAvwBA,wDAuwBA;EAvwBA;AAuwBA;AAvwBA;;EAAA;IAAA,gBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,iBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA,kBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,iBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA,iBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,mBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA;EAuwBA;AAAA;AAvwBA;;EAAA;IAAA;EAuwBA;;EAvwBA;IAAA,mBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,oBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA,oBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,qBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,qBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,qBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,kBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,eAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,mBAuwBA;IAvwBA;EAuwBA;;EAvwBA;IAAA,mBAuwBA;IAvwBA;EAuwBA;AAAA;AAvwBA;;EAAA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;AAAA;AAvwBA;;EAAA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;;EAvwBA;IAAA;EAuwBA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@layer base {\n  html {\n    font-size: 100%;\n    box-sizing: border-box;\n    scroll-behavior: smooth;\n    overflow-y: overlay;\n  }\n\n  * {\n    box-sizing: inherit;\n    font-family: IRANSansfa !important;\n    direction: rtl !important;\n  }\n\n  input,\n  select,\n  button {\n    font: inherit;\n  }\n}\n\n@layer components {\n  .container {\n    width: min(90vw, 1500px);\n    margin-inline: auto;\n  }\n\n  .placeholder::placeholder {\n    font-family: inherit;\n  }\n}\n\n.enterDrag {\n  animation: myfirst 6s;\n  animation-timing-function: linear;\n  animation-iteration-count: infinite;\n  background-color: transparent;\n  background-image: linear-gradient(\n      0deg,\n      transparent,\n      transparent 50%,\n      rgb(82, 80, 80) 0,\n      rgb(82, 80, 80)\n    ),\n    linear-gradient(\n      0deg,\n      transparent,\n      transparent,\n      transparent 50%,\n      rgb(82, 80, 80) 0,\n      rgb(82, 80, 80)\n    ),\n    linear-gradient(\n      90deg,\n      transparent,\n      transparent 50%,\n      rgb(82, 80, 80) 0,\n      rgb(82, 80, 80)\n    ),\n    linear-gradient(\n      90deg,\n      transparent,\n      transparent 50%,\n      rgb(82, 80, 80) 0,\n      rgb(82, 80, 80)\n    );\n  background-repeat: repeat-y, repeat-y, repeat-x, repeat-x;\n  background-size: 2px 20px, 2px 20px, 20px 2px, 20px 2px;\n  opacity: 0.7;\n  border-radius: 8px;\n}\n@keyframes myfirst {\n  0% {\n    background-position: 0 0, 100% 100%, 100% 0, 0 100%;\n  }\n  100% {\n    background-position: 0 +100px, 100% 0%, 0 0, 100% 100%;\n  }\n}\n.leftTextArea textarea {\n  direction: ltr !important;\n}\n.MuiPagination-ul {\n  flex-direction: row-reverse !important;\n}\n.tether-element {\n  z-index: 10000;\n}\n.datepicker-input {\n  display: none;\n  position: absolute;\n  top: 0;\n}\n.rc-time-picker {\n  display: none !important;\n}\n.border-print {\n  /*   border-radius: 10px !important;\n  border: 1px solid gray !important; */\n  /*   margin-top: 10px !important;\n  margin-bottom: 10px !important; */\n  padding-left: 40px !important;\n  padding-right: 40px !important;\n\n  line-height: 22px;\n  font-size: 15px;\n}\n\n.border-print h1.text-center {\n  text-align: center !important;\n}\n\n.border-print h2.text-center {\n  font-size: 16px;\n}\n\nbutton.btn.hamtaBtn.text-white.blacColorHover {\n  width: 40%;\n}\n\n.border-print > p {\n  text-align: center;\n  color: red;\n}\n\n/*invoice print responsive ------------------*/\n\n@media only screen and (max-width: 768px) {\n  .border-print {\n    max-width: 405px !important;\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n    font-size: 13px;\n  }\n  .border-print .row {\n    margin-bottom: 5px !important;\n    width: 100%;\n    margin-left: 0px;\n    margin-right: 0px;\n  }\n  .border-print > div:nth-child(4) > div > div {\n    overflow-y: hidden;\n  }\n}\n.alert-warning {\n  color: #ff0000;\n  background-color: #ffffff;\n  border-color: white;\n  padding-top: 50px;\n}\n.table-hover tbody tr:hover {\n  background-color: rgb(106 148 255 / 8%);\n  border: 1px solid #ff090936 !important;\n}\n\ntr.GridViewHeader {\n  border: 2px solid #b7b7b7 !important;\n  background: #f1f1f1;\n}\n\ntr.GridViewHeader > th {\n  border-bottom: 2px solid #b7b7b7 !important;\n}\n.alert-dark {\n  color: #1b1e21;\n  background-color: #d6d8d9;\n  border-color: #c6c8ca;\n}\n.alert-dark hr {\n  border-top-color: #b9bbbe;\n}\n.alert-dark .alert-link {\n  color: #040505;\n}\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n#printContent span,\n#printContent p,\n#printContent th,\n#printContent td {\n  font-size: 12px !important;\n}\n.MuiFormControl-root .Mui-disabled {\n  color: #040505 !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #040505 !important;\n}\n\n.invoicePage .border-print {\n  /*   border-radius: 0px !important; */\n  /*   border: 1px solid gray !important; */\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n  padding-top: 3px !important;\n  padding-bottom: 3px !important;\n  line-height: 16px;\n  font-size: 15px;\n}\n\n.invoicePage\n  .text-left.flex.items-center.justify-between.w-48.text-base.font-bold {\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.invoicePage thead.bg-\\[\\#d6d8d9\\] {\n  background: #eaeaea;\n}\n\n.invoicePage tr.text-center th {\n  font-weight: 400;\n}\n\n.invoicePage span.text-sm.font-bold {\n  font-weight: 300;\n}\n\n.invoicePage span.text-xs {\n  font-weight: 500;\n}\n\n.invoicePage tr.bg-\\[\\#d6d8d9\\] {\n  background: #eaeaea;\n}\n\n.invoicePage h2.text-center.font-extrabold {\n  font-size: 12px;\n}\n\n.invoicePage .text-sm {\n  font-size: 12px;\n  line-height: 12px;\n}\n\n.invoicePage .col-span-3.bg-\\[\\#d6d8d9\\].py-2.border.border-black.mt-3 {\n  padding: 2px;\n}\n.invoicePage .col-span-3.bg-\\[\\#d6d8d9\\].py-2.border.border-black {\n  padding: 2px;\n}\n.invoicePage h1.text-center.text-base.font-bold {\n  font-size: 12px;\n}\n\n.invoicePage #printContent span,\n#printContent p,\n#printContent th,\n#printContent td {\n  font-size: 11px !important;\n}\n\n.invoicePage\n  .text-left.flex.items-center.justify-between.w-48.text-base.font-bold {\n  font-size: 11px;\n}\n\n.invoicePage .w-48 {\n  width: 100px;\n}\n\n.invoicePage .pt-6 {\n  padding-top: 12px;\n}\n\n.invoicePage .gap-4.mt-10.mb-1.pt-6 {\n  margin: 0;\n}\n\n#printContent {\n  border: none !important;\n}\n.checkBoxDisabled.Mui-disabled {\n  background-color: #fff !important;\n  color: #595959 !important;\n}\n.checkBoxDisabled .Mui-disabled {\n  background-color: #fff !important;\n  color: #595959 !important;\n}\n.smallNumberInput .MuiTextField-root {\n  width: 50px !important;\n}\n.smallNumberInput input {\n  text-align: center !important;\n}\n.noborderBefore::before {\n  background-color: transparent !important;\n}\n.MuiDrawer-paper {\n  right: 0 !important;\n  left: auto !important;\n}\n.tabss .Mui-disabled {\n  background-color: transparent !important;\n}\n.loadingPage {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  backdrop-filter: blur(5px);\n  filter: blur(5px);\n  z-index: 1000;\n}\n.btn {\n  align-items: center;\n  border-radius: 5px;\n  color: white;\n  cursor: pointer;\n  display: inline-flex;\n\n  justify-content: center;\n  min-width: 90px;\n}\n.btn.btn--loading {\n  font-size: 0;\n  position: absolute;\n  right: 50%;\n  top: 50%;\n  transform: translate(50%, -50%);\n}\n.btn.btn--loading span {\n  display: flex;\n}\n.btn.btn--loading span b {\n  animation-direction: alternate;\n  animation-duration: 0.5s;\n  animation-fill-mode: none;\n  animation-iteration-count: infinite;\n  animation-name: stretch;\n  animation-play-state: running;\n  animation-timing-function: ease-out;\n  border-radius: 100%;\n  display: block;\n  height: 10px;\n  margin: 0 1px;\n  width: 10px;\n  animation-delay: 0.1s;\n  margin: 0 5px;\n}\n.btn.btn--loading span b:first-child {\n  animation-delay: 0s;\n  margin: 0;\n}\n.btn.btn--loading span b:last-child {\n  animation-delay: 0.2s;\n  margin: 0;\n}\n.btn b {\n  font-weight: normal;\n}\n.btn span {\n  display: none;\n}\n@keyframes stretch {\n  0% {\n    transform: scale(0.5);\n    background-color: #b5ddf0;\n  }\n  50% {\n    background-color: #cfe9f6;\n  }\n  100% {\n    transform: scale(1);\n    background-color: #ffffff;\n  }\n}\n\n.sidebar::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n\n  background-color: #f5f5f5;\n}\n\n.sidebar::-webkit-scrollbar {\n  width: 6px;\n  background-color: #f5f5f5;\n}\n\n.sidebar::-webkit-scrollbar {\n  display: none !important;\n}\n.sidebar:hover::-webkit-scrollbar {\n  display: block !important;\n}\n.sidebar::-webkit-scrollbar-thumb {\n  border-radius: 6px;\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #d5d6d8;\n}\n\n/* html::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n\n  background-color: #f5f5f5;\n}\n\nhtml::-webkit-scrollbar {\n  width: 6px;\n  background-color: #f5f5f5;\n}\n\nhtml::-webkit-scrollbar-thumb {\n  border-radius: 6px;\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #6e747a;\n}\n */\n.MuiTableCell-sizeMedium {\n  font-size: 0.77rem !important;\n}\n.MuiTableCell-body {\n  font-size: 0.77rem !important;\n}\n.MuiTableCell-root {\n  padding: 6px 4px !important;\n}\n/* .MuiTableContainer-root::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  background-color: #f5f5f5;\n}\n\n.MuiTableContainer-root::-webkit-scrollbar {\n  width: 12px;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n}\n\n.MuiTableContainer-root::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  background-color: #6e747a;\n} */\n.MuiInputBase-root {\n  height: 3.07rem !important;\n}\n\n.MuiFormLabel-root {\n  font-size: 0.75rem !important;\n  transform: translate(-14px, 0.9rem) scale(1) !important;\n}\n.MuiInputLabel-shrink {\n  transform: translate(-14px, -0.57rem) scale(0.75) !important;\n  color: #001ee4 !important;\n}\n.MuiOutlinedInput-root {\n  padding-left: 0 !important;\n}\n.MuiInputBase-input {\n  font-size: 0.75rem !important;\n  padding: 6px !important;\n  font-weight: 500 !important;\n}\n\n.MuiInputBase-multiline {\n  height: unset !important;\n}\n.tox-promotion {\n  display: none !important;\n}\n.tox-statusbar__branding {\n  display: none !important;\n}\n.tox-statusbar__wordcount {\n  display: none !important;\n}\n.MuiCircularProgress-root {\n  width: 20px !important;\n  height: 20px !important;\n}\n.userInput .MuiInputBase-root {\n  height: 26px !important;\n}\n.login .MuiInputBase-root {\n  height: 40px !important;\n}\n\n.img-croper-body {\n  width: 100%;\n  min-height: 400px;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.img-croper-body img {\n  max-width: 500px !important;\n  max-height: 500px !important;\n  width: 100%;\n  height: 100%;\n  min-height: 400px;\n  min-width: 400px;\n}\n.img-croper-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  /* display: none; <- Crashes Chrome on hover */\n  -webkit-appearance: none;\n  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield; /* Firefox */\n}\n.MuiButtonBase-root {\n  font-size: 0.9rem !important;\n  padding: 4px 6px !important;\n  font-weight: 400 !important;\n}\n.MuiTabs-root .Mui-selected {\n  background-color: #d8effa !important;\n}\n\n.MuiAutocomplete-root .MuiInputBase-root {\n  height: unset !important;\n}\n\n.MuiSwitch-switchBase {\n  padding: 9px !important;\n}\n\n.MuiListItemIcon-root {\n  min-width: 35px !important;\n}\n.sideBarActive {\n  position: absolute;\n  right: -24px;\n  width: 4px;\n  height: 20px;\n  background: #001ee4;\n  border-top-left-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\ntextarea {\n  resize: vertical !important;\n}\n.MuiButtonBase-root {\n  box-shadow: none !important;\n}\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px white inset !important;\n}\n.selectToday {\n  background-color: #198dff;\n}\n.MuiButton-contained {\n  height: 3.07rem !important;\n  font-size: 0.75rem !important;\n}\n.MuiCheckbox-root svg {\n  width: 0.8em;\n  height: 0.8em;\n}\n.MuiAutocomplete-tag {\n  margin: 5px !important;\n  background-color: rgba(25, 63, 210, 0.08) !important;\n  border: unset !important;\n  color: black !important;\n}\n.MuiAutocomplete-tag .MuiSvgIcon-root {\n  color: rgba(244, 95, 97, 0.729) !important;\n}\n.MuiChip-label {\n  font-weight: 500 !important;\n}\n.MuiAutocomplete-clearIndicator {\n  visibility: visible !important;\n  color: rgb(244, 95, 97) !important;\n}\n.customAddButton {\n  font-size: 1.5rem !important;\n  color: #fff !important;\n  background-color: #60b5db !important;\n  border-radius: 55px !important;\n  width: 1em !important;\n  height: 1em !important;\n}\n.MuiButton-outlined {\n  height: 3.07rem !important;\n  font-size: 0.75rem !important;\n}\n.login .MuiFormLabel-root,\n.login .MuiInputBase-input {\n  font-size: 1.3rem !important;\n}\n.biggerInput .MuiFormLabel-root,\n.biggerInput .MuiInputBase-input {\n  font-size: 1rem !important;\n}\n\n.bigTable .MuiTableCell-body {\n  font-size: 1rem !important;\n}\n.MuiChip-label {\n  font-size: 0.75rem !important;\n}\n@media only screen and (max-width: 768px) {\n  .MuiInputBase-input,\n  .MuiFormLabel-root,\n  .MuiButton-contained,\n  span,\n  p,\n  small,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  input label,\n  a,\n  td,\n  tr,\n  th,\n  .MuiTypography-root,\n  .MuiTableCell-body,\n  div {\n    font-size: 14px !important;\n  }\n  .MuiChip-label {\n    font-size: 0.7rem !important;\n  }\n  .ril-image-current {\n    transform: none !important;\n    width: 100% !important;\n    /*     height: 100% !important; */\n  }\n  .ril-zoom-in {\n    display: none !important;\n  }\n  .ril-zoom-out {\n    display: none !important;\n  }\n  .MuiAutocomplete-popper {\n    max-width: 300px !important;\n    /*     left: 0!important; */\n  }\n  .smalllerText {\n    font-size: 0.77rem !important;\n  }\n}\n.darkMode .MuiTabs-root .Mui-selected {\n  background-color: #25114f !important;\n}\n.darkMode .MuiFormControl-root .Mui-disabled {\n  color: #b2dada !important;\n  opacity: 1 !important;\n  -webkit-text-fill-color: #c4f1f1 !important;\n}\n.darkMode .MuiInputLabel-shrink {\n  transform: translate(-14px, -0.57rem) scale(0.75) !important;\n  color: #90caf9 !important;\n}\n.darkMode .text-\\[\\#000\\] {\n  color: #fff !important;\n}\n.darkMode .MuiAutocomplete-tag {\n  color: #b2dada !important;\n}\n.darkMode button[disabled],\nbutton[disabled]:hover {\n  color: #aaa;\n  cursor: not-allowed;\n  background-color: #403f3f !important;\n}\n.MuiTabs-scroller {\n  overflow-x: hidden !important;\n}\n.MuiTabs-scroller:hover {\n  overflow-x: auto !important;\n}\n.MuiTabs-scroller::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n\n  background-color: #f5f5f5;\n}\n\n.MuiTabs-scroller::-webkit-scrollbar {\n  height: 4px;\n  background-color: #f5f5f5;\n}\n\n.MuiTabs-scroller::-webkit-scrollbar-thumb {\n  border-radius: 3px;\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n  background-color: #6e747a;\n}\n.iranMap path {\n  fill: white;\n}\n.noPadding .MuiSwitch-switchBase {\n  padding: 0px !important;\n}\n.noPadding .MuiSwitch-thumb {\n  position: relative;\n  z-index: 10;\n}\n\n.MuiButton-contained {\n  color: #fff !important;\n}\n\n.ril__closeButton {\n  background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=\")\n    no-repeat center !important;\n}\n\n.ril__zoomInButton {\n  background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+\")\n    no-repeat center !important;\n}\n\n.ril__zoomOutButton {\n  background: url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=\")\n    no-repeat center !important;\n}\n.ril-image-current {\n  border-radius: 10px;\n}\n.MapMainCom {\n  width: 100%;\n  height: 40rem;\n  z-index: 100;\n  position: relative;\n  margin-top: 2rem;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.MapMainCom .leaflet-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.leaflet-div-icon {\n  border: 0 !important;\n  background: transparent !important;\n}\n.leftInput input {\n  direction: ltr !important;\n}\n.leftInput .MuiAutocomplete-endAdornment {\n  left: unset !important;\n  right: 10px !important;\n}\n.leftInput .MuiAutocomplete-root .MuiFormControl-root {\n  height: 3rem !important;\n}\n.leftInput .MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 7px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
